import React, { useContext, useState, useEffect } from "react";
import { Container, Row, Col, Button, Table, Form } from "react-bootstrap";
import "./Create.css";
import Select from "react-select";
import Header from "../../../Header/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModalSave from "../../../common/ModelSave";
import { useNavigate } from "react-router";
import JoditEditor from "jodit-react";
import { variant_type } from "../../../../utils/common";
import SingleVarient from "../DoubleVarient";
import DoubleVarient from "../DoubleVarient";
function Create() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
    postData,
    getDimension,
  } = useContext(Context);

  const [submitLoading, setSubmitLoading] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
    trigger,
    setValue,
    clearErrors,
    setError,
  } = useForm({
    defaultValues: {
      variants: [
        {
          name: "",
          price: "",
          pv: "",
          mrp: "",
          image: "",
          description: "",
        },
      ], // Default empty field
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "variants",
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [variantsError, setVariantsError] = useState("");

  useEffect(() => {
    register("variants", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setVariantsError(isValid ? "" : "At least one variant is required");
        return isValid;
      },
    });
  }, [register]);
  const variantType = watch("variant_type_id");

  const isJoiningKit = watch("is_joining_kit")?.value;

  const onSubmit = async (data) => {
    try {
      setSubmitLoading(true);
      const DataToSend = new FormData();
      if (data?.name) DataToSend.append("name", data?.name);
      if (data?.price) DataToSend.append("price", data?.price);
      if (data?.mrp) DataToSend.append("mrp", data?.mrp);
      if (data?.description)
        DataToSend.append("description", data?.description);
      if (data?.manufacturer)
        DataToSend.append("manufacturer", data?.manufacturer);
      if (data?.features) DataToSend.append("features", data?.features);
      if (data?.specification)
        DataToSend.append("specification", data?.specification);
      if (data?.care) DataToSend.append("care", data?.care);
      if (data?.delivery) DataToSend.append("delivery", data?.delivery);
      if (data?.warranty) DataToSend.append("warranty", data?.warranty);
      if (data?.tax_percentage)
        DataToSend.append("tax_percentage", data?.tax_percentage);
      if (data?.p_category_id?.value)
        DataToSend.append("p_category_id", data?.p_category_id?.value);
      if (data?.shape_id?.value)
        DataToSend.append("shape_id", data?.shape_id?.value);
      if (data?.p_sub_category_id?.value)
        DataToSend.append("p_sub_category_id", data?.p_sub_category_id?.value);
      if (data?.expity_date_days)
        DataToSend.append("expity_date_days", data?.expity_date_days);
      // DataToSend.append("expiry_date", data?.expiry_date);

      // if (data?.variant_type_id?.value) {
      DataToSend.append("variant_type_id", variant_type.Single);
      // }

      if (data?.p_child_category_id?.value) {
        DataToSend.append(
          "p_child_category_id",
          data?.p_child_category_id?.value,
        );
      }
      if (data?.unit_id?.value)
        DataToSend.append("unit_id", data?.unit_id?.value);

      if (data?.brand_id?.value) {
        DataToSend.append("brand_id", data?.brand_id?.value);
      }

      const imageFile = data.image?.[0];

      if (imageFile instanceof File) {
        DataToSend.append("image", imageFile);
      }

      // if (data?.image && data?.image[0]) {
      //   DataToSend.append("image", data.image[0]);
      // }
      // DataToSend.append("video", data.video[0]);
      if (data?.lic_no) DataToSend.append("lic_no", data?.lic_no);
      if (data?.tag) DataToSend.append("tag", data?.tag);
      if (data?.measurements)
        DataToSend.append("measurements", data?.measurements);

      // if (data?.is_cod) {
      //   DataToSend.append("is_cod", data?.is_cod);
      // }

      if (data?.is_joining_kit?.value) {
        DataToSend.append("is_joining_kit", data?.is_joining_kit?.value);
      }
      // if (data?.joining_bonus && isJoiningKit) {
      //   DataToSend.append("joining_bonus", data?.joining_bonus);
      // }
      if (data?.advantages_status) {
        DataToSend.append("advantages_status", data?.advantages_status);
      }
      if (data?.composition_status) {
        DataToSend.append("composition_status", data?.composition_status);
      }
      if (data?.description_status) {
        DataToSend.append("description_status", data?.description_status);
      }
      if (data?.made_in_id?.value)
        DataToSend.append("made_in_id", data?.made_in_id?.value);
      if (data?.delivery_charges)
        DataToSend.append("delivery_charges", data?.delivery_charges);

      // Append the images (multiple files)
      if (data?.images && data?.images.length > 0) {
        for (let i = 0; i < data.images.length; i++) {
          DataToSend.append("images", data.images[i]);
        }
      }

      // DataToSend.append(
      //   "delivery_type_id",
      //   JSON.stringify(data.delivery_type_id.map((option) => option.value))
      // );

      const variants = [];

      data.variants?.forEach((variant) => {
        const singleVariant = {
          price: variant?.price ?? null,
          pv: variant?.pv ?? null,
          mrp: variant?.mrp ?? null,
          metal_id: variant?.metal_id ?? null,
          description: variant?.description ?? null,
          double_variants: [],
        };

        if (Array.isArray(variant?.double_variants)) {
          variant.double_variants.forEach((doubleVal) => {
            const doubleVariant = {
              mrp: doubleVal?.mrp ?? null,
              price: doubleVal?.price ?? null,
              size_id: doubleVal?.size_id ?? null,
              triple_variants: [],
            };

            if (Array.isArray(doubleVal?.triple_variants)) {
              doubleVal.triple_variants.forEach((tripleVal) => {
                doubleVariant.triple_variants.push({
                  mrp: tripleVal?.mrp ?? null,
                  price: tripleVal?.price ?? null,
                  diamond_id: tripleVal?.diamond_id ?? null,
                });
              });
            }

            singleVariant.double_variants.push(doubleVariant);
          });
        }

        variants.push(singleVariant);
      });

      DataToSend.append("variants", JSON.stringify(variants));
      // if (data?.levels?.length > 0) {
      //   DataToSend.append("level_commission", JSON.stringify(data?.levels));
      // }
      // if (data?.levels?.length > 0 && !isJoiningKit) {
      //   DataToSend.append("level_commission", JSON.stringify(data?.levels));
      // }

      const response = await postData("/admin/products", DataToSend);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        reset();
        setShowModal(0);
        navigate("/products");
      }, 1000);
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitLoading(false);
    }
  };

  const [Countries, setCountries] = useState([]);

  const [units, setUnits] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  // const [childCategories, setChildCategories] = useState([]);
  const [VarientType, setVarientType] = useState([]);
  const [DeliveryType, setDeliveryType] = useState([]);

  const [level, setLevel] = useState([]);

  const getAllLevel = async () => {
    const response = await getData(`/common/masters/all-level?status=true`);
    if (response?.success) {
      setLevel(await Select2Data(response?.data, "level_id"));
    }
  };

  const getAllUnits = async () => {
    const response = await getData(`/common/masters/all-units`);
    if (response?.success) {
      const result = response?.data?.map((data) => ({
        value: data?.id,
        label: data?.name,
        name: "unit_id",
        sub_name: `${data?.commission_unit_value || ""} ${data?.commission_unit || ""}`,
      }));

      setUnits(result);
    }
  };
  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-p-category");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
  const getAllSubCategories = async (id) => {
    const response = await getData(
      `/common/masters/all-vendor-p-sub-categories/${id}`,
    );
    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "p_sub_category_id"));
    }
  };

  // const getAllChildCategories = async (id) => {
  //   const response = await getData(
  //     `/common/masters/all-p-child-category/${id}`,
  //   );
  //   if (response?.success) {
  //     setChildCategories(
  //       await Select2Data(response?.data, "p_child_category_id"),
  //     );
  //   }
  // };

  const getAllVarientType = async () => {
    const response = await getData(`/common/masters/all-variant-type`);
    if (response?.success) {
      setVarientType(await Select2Data(response?.data, "stock_type_id"));
    }
  };

  const getAllDeliveryType = async () => {
    const response = await getData(`/common/masters//all-delivery-type`);
    if (response?.success) {
      setDeliveryType(await Select2Data(response?.data, "farmer_id"));
    }
  };
  useEffect(() => {
    getAllLevel();

    getAllUnits();
    getAllCategories();
    getAllVarientType();
    getAllDeliveryType();
  }, []);

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview
  const imageFile = watch("image");

  useEffect(() => {
    if (imageFile && imageFile[0]) {
      setImagePreview(URL.createObjectURL(imageFile[0]));
      return () => URL.revokeObjectURL(imageFile[0]); // cleanup
    } else {
      setImagePreview(null);
    }
  }, [imageFile]);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setValue("image", file, {
      shouldValidate: true,
      shouldDirty: true,
    });

    setImagePreview(URL.createObjectURL(file));

    trigger("image");

    e.target.value = "";
  };

  const removeThumbnail = () => {
    setImagePreview(null);

    // Clear file input in react-hook-form
    setValue("image", null, { shouldValidate: true });

    // Clear actual input element
    const input = document.querySelector('input[name="image"]');
    if (input) {
      input.value = "";
    }

    trigger("image");
  };

  const [imagePreviews, setImagePreviews] = useState([]);

  const handleImagesChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);

    if (!selectedFiles.length) return;

    const existingFiles = getValues("images") || [];

    const updatedFiles = [...existingFiles, ...selectedFiles];

    setValue("images", updatedFiles, {
      shouldValidate: true,
      shouldDirty: true,
    });

    setImagePreviews((prev) => [
      ...prev,
      ...selectedFiles.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      })),
    ]);

    trigger("images");

    e.target.value = "";
  };
  const removeImage = (index) => {
    const files = [...(getValues("images") || [])];
    const previews = [...imagePreviews];

    URL.revokeObjectURL(previews[index].preview);

    files.splice(index, 1);
    previews.splice(index, 1);

    setValue("images", files, {
      shouldValidate: true,
      shouldDirty: true,
    });

    setImagePreviews(previews);

    trigger("images");
  };

  useEffect(() => {
    register("images", {
      validate: (value) => {
        return value?.length > 0 || "Please select at least one image";
      },
    });
  }, [register]);

  const [videoPreview, setVideoPreview] = useState(null);
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setVideoPreview(previewUrl);
    }
  };

  const [Metals, setMetal] = useState([]);
  const getAllMetal = async () => {
    const response = await getData(`/common/masters/all-metal`);
    if (response?.success) {
      setMetal(await Select2Data(response?.data, "metal_id"));
    }
  };

  const [Sizes, setSize] = useState([]);
  const getAllSize = async () => {
    const response = await getData(`/common/masters/all-size`);
    if (response?.success) {
      setSize(await Select2Data(response?.data, "size_id"));
    }
  };

  const [Diamonds, setDiamond] = useState([]);
  const getAllDiamond = async () => {
    const response = await getData(`/common/masters/all-diamond`);
    if (response?.success) {
      setDiamond(await Select2Data(response?.data, "diamond_id"));
    }
  };

  useEffect(() => {
    getAllSize();
    getAllDiamond();
    getAllMetal();
  }, []);

  const unit_id = watch("unit_id");

  return (
    <>
      <Header title={"Create Product"} link={"/employee/employee_details"} />
      <section className="Create">
        {/* back button start */}
        <div className="back_btn_holder d-flex ">
          <div onClick={() => navigate(`/products`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>
        {/* back button end */}

        <Form>
          {/* 1. Order Details start */}
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>1. Product Category</h6>
            </div>
            <div className="package-details-section">
              <div className="pending-table ">
                <div className="row ">
                  <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                    <Form.Label>Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={categories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            getAllSubCategories(selectedValue?.value);
                            setValue("p_sub_category_id", "");
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_category_id && (
                      <span className="text-danger">
                        {errors.p_category_id.message}
                      </span>
                    )}
                  </div>

                  <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                    <Form.Label>Sub Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_sub_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Sub Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_sub_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={subCategories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            // getAllChildCategories(selectedValue?.value);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_sub_category_id && (
                      <span className="text-danger">
                        {errors.p_sub_category_id.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>2. Product</h6>
            </div>
            <div className="package-details-section">
              {/* Package Weight */}
              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">Name</div>
                </Col>
                <Col lg={4} md={4}>
                  <div className="">
                    <Form.Control
                      type="text"
                      name={`name`}
                      placeholder="name"
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      {...register(`name`, {
                        required: "name is required",
                        validate: (value) => {
                          const words = value.match(/\b\w+\b/g);
                          return (
                            !words ||
                            words.length <= 50 ||
                            "Data must be 100 words or less"
                          );
                        },
                      })}
                    />
                  </div>
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">
                    Thumbnail Upload image (928 × 945 px).
                  </div>
                </Col>
                <Col lg={4} md={4}>
                  <div className="">
                    <Form.Control
                      type="file"
                      name="image"
                      placeholder="Image"
                      className={classNames("", {
                        "is-invalid": errors?.image,
                      })}
                      {...register("image", {
                        required: "Image is required",
                      })}
                      accept="image/jpeg,image/png,image/webp"
                      // onChange={handleImageChange}
                    />
                  </div>
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </Col>
                <Col lg={4} md={4}>
                  {imagePreview && (
                    <div className="Preview_img_holder">
                      <img
                        className="Preview_img"
                        src={imagePreview}
                        alt="Category Preview"
                        style={{ maxWidth: "300px" }}
                      />
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">Unit</div>
                </Col>
                <Col lg={4} md={4}>
                  <div className=" ">
                    <Controller
                      className="select-contoller "
                      name={`unit_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Unit",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.unit_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={units}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                  </div>
                  {errors.unit_id && (
                    <span className="text-danger">
                      {errors.unit_id.message}
                    </span>
                  )}
                </Col>
              </Row>

              {/* <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">Landing Price</div>
                </Col>

                <Col lg={4} md={4}>
                  <Form.Control
                    type="text"
                    name={`price`} // Register color for the variant
                    placeholder="Vishwaroop Landing Price"
                    className={classNames("", {
                      "is-invalid": errors?.price,
                    })}
                    {...register(`price`, {
                      required: "Vishwaroop Landing Price is required",
                    })}
                    onKeyDown={(e) => {
                      // Allow backspace, left and right arrow keys
                      if (
                        e.key === "Backspace" ||
                        e.key === "ArrowLeft" ||
                        e.key === "ArrowRight"
                      ) {
                        return; // Allow the action to continue
                      }

                      // Allow digits and decimal point
                      if (!/[\d.]/.test(e.key)) {
                        e.preventDefault(); // Block the invalid key
                      }

                      // Prevent multiple decimal points
                      if (e.key === "." && e.target.value.includes(".")) {
                        e.preventDefault(); // Block adding another decimal point
                      }
                    }}
                  />

                  {errors.price && (
                    <span className="text-danger">{errors.price.message}</span>
                  )}
                </Col>
              </Row> */}

              {/* <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">Delivery Chargers</div>
                  {unit_id?.value && (
                    <small className="text-danger d-block mt-1">
                      *Enter Delivery charges For {unit_id?.sub_name || ""}
                    </small>
                  )}
                </Col>

                <Col lg={4} md={4}>
                  <div className=" ">
                    <Form.Control
                      type="text"
                      name={`delivery_charges`}
                      placeholder="Delivery Chargers"
                      className={classNames("", {
                        "is-invalid": errors?.delivery_charges, // Adjusted error checking
                      })}
                      {...register(`delivery_charges`, {
                        required: "Delivery Chargers is required",

                        min: {
                          value: 0,
                          message: "Amount must be greater than or equal to 0",
                        },

                        validate: (value) =>
                          Number(value) >= 0 || "Invalid delivery Chargers",
                      })}
                    />
                  </div>
                  {errors.delivery_charges && (
                    <span className="text-danger">
                      {errors.delivery_charges.message}
                    </span>
                  )}
                </Col>
              </Row> */}

              {/* <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">Is Joining Kit</div>
                </Col>
                <Col lg={4} md={4}>
                  <div className=" ">
                    <Controller
                      name="is_joining_kit"
                      control={control}
                      defaultValue={{
                        value: false,
                        label: "No",
                      }}
                      rules={{
                        required: "Select Joining Kit Status",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.is_joining_kit
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                  </div>
                  {errors.is_joining_kit && (
                    <span className="text-danger">
                      {errors.is_joining_kit.message}
                    </span>
                  )}
                </Col>
              </Row> */}
              {/* {isJoiningKit && (
                <Row className="detail-row">
                  <Col md={4}>
                    <div className="detail-label">Joining Bonus</div>
                  </Col>
                  <Col lg={4} md={4}>
                    <div className=" ">
                      <Form.Control
                        type="text"
                        name={`joining_bonus`}
                        placeholder="Joining Bonus"
                        className={classNames("", {
                          "is-invalid": errors?.joining_bonus, // Adjusted error checking
                        })}
                        {...register(`joining_bonus`, {
                          required: "Joining Bonus is required",

                          min: {
                            value: 1,
                            message:
                              "Amount must be greater than or equal to 1",
                          },

                          validate: (value) =>
                            Number(value) >= 1 || "Invalid joining Bonus",
                        })}
                      />
                    </div>
                    {errors.joining_bonus && (
                      <span className="text-danger">
                        {errors.joining_bonus.message}
                      </span>
                    )}
                  </Col>
                </Row>
              )} */}
            </div>
          </div>

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>3. Details</h6>
            </div>

            <div className="package-details-section">
              <Row className="detail-row">
                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Tax Percentage</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name="tax_percentage"
                          placeholder="Tax Percentage (%)"
                          className={classNames("", {
                            "is-invalid": errors?.tax_percentage,
                          })}
                          {...register("tax_percentage", {
                            validate: (value) => {
                              // Optional field
                              if (!value || value.trim() === "") {
                                return true;
                              }

                              const numericValue = parseFloat(value);

                              if (isNaN(numericValue)) {
                                return "Please enter a valid tax percentage";
                              }

                              if (numericValue < 0) {
                                return "Tax percentage cannot be negative";
                              }

                              if (numericValue > 100) {
                                return "Tax percentage cannot exceed 100";
                              }

                              return true;
                            },
                          })}
                          onKeyDown={(e) => {
                            if (
                              !/[0-9]/.test(e.key) &&
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight" &&
                              e.key !== "." &&
                              e.key !== "Tab" &&
                              e.key !== "Delete"
                            ) {
                              e.preventDefault();
                            }

                            if (e.key === "." && e.target.value.includes(".")) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (value && parseFloat(value) > 100) {
                              e.target.value = "100";
                            }
                          }}
                        />
                        {errors.tax_percentage && (
                          <span className="text-danger">
                            {errors.tax_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>License No</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`lic_no`}
                          placeholder="License No"
                          className={classNames("", {
                            "is-invalid": errors?.lic_no, // Adjusted error checking
                          })}
                          {...register(`lic_no`, {
                            // required: "License No is required",
                          })}
                        />
                        {errors.lic_no && (
                          <span className="text-danger">
                            {errors.lic_no.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>HSN Code</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`tag`}
                          placeholder="HSN Code"
                          className={classNames("", {
                            "is-invalid": errors?.tag, // Adjusted error checking
                          })}
                          {...register(`tag`, {
                            // required: "License No is required",
                          })}
                        />
                        {errors.tag && (
                          <span className="text-danger">
                            {errors.tag.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Description</Form.Label>
                      <Form.Group>
                        <Controller
                          name="description"
                          control={control}
                          rules={{
                            required: "description is required.",
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("description");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.description && (
                          <span className="text-danger">
                            {errors.description.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Packaging & Delivery</Form.Label>
                      <Form.Group>
                        <Controller
                          name="delivery"
                          control={control}
                          rules={{
                            required: "Packaging & Delivery is required.",
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("delivery");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.delivery && (
                          <span className="text-danger">
                            {errors.delivery.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Additional Feature</Form.Label>
                      <Form.Group>
                        <Controller
                          name="features"
                          control={control}
                          rules={{
                            required: "Additional Feature is required.",
                          }}
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("features");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.features && (
                          <span className="text-danger">
                            {errors.features.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>4. Images Upload image (928 × 945 px).</h6>
            </div>
            <div className="package-details-section">
              {/* Pickup Slot */}
              <Row className="detail-row">
                <Col lg={4} md={4}>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type="file"
                      multiple
                      accept="image/jpeg,image/png,image/webp"
                      onChange={handleImagesChange}
                    />
                  </div>
                  {errors.images && (
                    <span className="text-danger">{errors.images.message}</span>
                  )}
                </Col>
                <div className="img-row-holder mt-2 mx-3 position-relative">
                  <div className="img-row-holder">
                    {imagePreviews.map((image, index) => (
                      <div className="preview-item" key={index}>
                        <img
                          src={image.preview}
                          className="preview-img"
                          alt={`Preview ${index + 1}`}
                        />

                        <button
                          type="button"
                          className="remove-btn"
                          onClick={() => removeImage(index)}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </Row>
            </div>
          </div>
          {/* {!isJoiningKit && ( */}
          {/* <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>5. Product Level Commissions</h6>
            </div>
            <div className="package-details-section">
              {unit_id?.value && (
                <small className="text-danger d-block mt-1">
                  *You will be entering commission per {unit_id?.sub_name || ""}
                </small>
              )}
              <Row className="detail-row">
                {level?.map((level, index) => (
                  <Col md={6} lg={4} key={level.value}>
                    <div
                      className="main-form-section mt-3 p-3"
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "10px",
                      }}
                    >
                      <h5 className="mb-3">{level.label}</h5>

                      <Form.Group className="mb-3">
                        <Form.Label>Commission Percentage (%)</Form.Label>

                        <Form.Control
                          type="number"
                          step="0.01"
                          placeholder="Enter Percentage"
                          className={classNames("", {
                            "is-invalid": errors?.levels?.[index]?.percent,
                          })}
                          {...register(`levels.${index}.percent`, {
                            min: {
                              value: 1,
                              message:
                                "Percentage must be greater than or equal to 1",
                            },

                            max: {
                              value: 100,
                              message: "Percentage cannot be greater than 100",
                            },

                            validate: (value) => {
                              if (
                                value === undefined ||
                                value === null ||
                                value === ""
                              ) {
                                return true;
                              }

                              return (
                                Number(value) >= 0 ||
                                "Invalid percentage amount"
                              );
                            },
                          })}
                        />

                        {errors?.levels?.[index]?.percent && (
                          <span className="text-danger">
                            {errors?.levels?.[index]?.percent?.message}
                          </span>
                        )}
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Commission Amount</Form.Label>

                        <Form.Control
                          type="number"
                          step="0.01"
                          placeholder="Enter Amount"
                          className={classNames("", {
                            "is-invalid": errors?.levels?.[index]?.amount,
                          })}
                          {...register(`levels.${index}.amount`, {
                            min: {
                              value: 1,
                              message:
                                "Amount must be greater than or equal to 1",
                            },

                            validate: (value) => {
                              if (
                                value === undefined ||
                                value === null ||
                                value === ""
                              ) {
                                return true;
                              }

                              return (
                                Number(value) >= 0 ||
                                "Invalid commission amount"
                              );
                            },
                          })}
                        />

                        {errors?.levels?.[index]?.amount && (
                          <span className="text-danger">
                            {errors?.levels?.[index]?.amount?.message}
                          </span>
                        )}
                      </Form.Group>
                      <input
                        type="hidden"
                        value={level.value}
                        {...register(`levels.${index}.level_id`)}
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div> */}
          {/* )} */}

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>6. Variants</h6>
            </div>

            <div className="package-details-section">
              {fields.map((variant, index) => (
                <div key={variant.id} className="main-form-section mt-3">
                  <Row>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>
                            Variant {index + 1}{" "}
                            {unit_id?.value ? ` (${unit_id?.label})` : ""}
                          </Form.Label>
                          <Form.Group>
                            <Controller
                              className="select-contoller"
                              name={`variants.${index}.metal_id`}
                              control={control}
                              rules={{
                                required: `Enter Variant ${index + 1}`,
                                validate: (value) => {
                                  if (
                                    value === "" ||
                                    value === null ||
                                    value === undefined
                                  ) {
                                    return `Enter Variant ${index + 1}`;
                                  }

                                  // Allow only positive numbers and decimals
                                  const regex = /^\d+(\.\d+)?$/;

                                  return (
                                    regex.test(value) ||
                                    "Only positive numbers and decimals are allowed"
                                  );
                                },
                              }}
                              render={({
                                field: { onChange, onBlur, value, ref },
                              }) => (
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder={`Enter Variant ${index + 1}`}
                                  onChange={(e) => {
                                    let inputValue = e.target.value;

                                    // Remove invalid characters
                                    inputValue = inputValue.replace(
                                      /[^0-9.]/g,
                                      "",
                                    );

                                    // Prevent multiple decimals
                                    const parts = inputValue.split(".");
                                    if (parts.length > 2) {
                                      inputValue =
                                        parts[0] +
                                        "." +
                                        parts.slice(1).join("");
                                    }

                                    onChange(inputValue);
                                  }}
                                  onBlur={onBlur}
                                  value={value || ""}
                                  ref={ref}
                                  style={{
                                    borderColor: errors?.variants?.[index]
                                      ?.metal_id
                                      ? "red"
                                      : undefined,
                                  }}
                                />
                              )}
                            />

                            {errors?.variants?.[index]?.metal_id && (
                              <span className="text-danger">
                                {errors?.variants?.[index]?.metal_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Vishwaroop MRP</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`variants.${index}.mrp`} // Register color for the variant
                              placeholder="Vishwaroop MRP"
                              className={classNames("", {
                                "is-invalid": errors?.variants?.[index]?.mrp,
                              })}
                              {...register(`variants.${index}.mrp`, {
                                required: "Vishwaroop MRP is required",
                                min: {
                                  value: 1,
                                  message: "Vishwaroop MRP must be at least 1",
                                },
                                validate: (value) =>
                                  Number(value) >= 1 ||
                                  "Vishwaroop MRP must be at least 1",
                              })}
                              onKeyDown={(e) => {
                                // Allow backspace, left and right arrow keys
                                if (
                                  e.key === "Backspace" ||
                                  e.key === "ArrowLeft" ||
                                  e.key === "ArrowRight"
                                ) {
                                  return; // Allow the action to continue
                                }

                                // Allow digits and decimal point
                                if (!/[\d.]/.test(e.key)) {
                                  e.preventDefault(); // Block the invalid key
                                }

                                // Prevent multiple decimal points
                                if (
                                  e.key === "." &&
                                  e.target.value.includes(".")
                                ) {
                                  e.preventDefault(); // Block adding another decimal point
                                }
                              }}
                            />
                            {errors?.variants?.[index]?.mrp && (
                              <span className="text-danger">
                                {errors.variants[index].mrp.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Vishwaroop Discounted Price</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`variants.${index}.price`} // Register color for the variant
                              placeholder="Vishwaroop Discounted Price"
                              className={classNames("", {
                                "is-invalid": errors?.variants?.[index]?.price,
                              })}
                              {...register(`variants.${index}.price`, {
                                required:
                                  "Vishwaroop Discounted Price is required",
                                min: {
                                  value: 1,
                                  message:
                                    "Discounted Price must be at least 1",
                                },
                                validate: {
                                  minPrice: (value) =>
                                    Number(value) >= 1 ||
                                    "Discounted Price must be at least 1",
                                  lessThanPrice: (value) => {
                                    const mrp = getValues(
                                      `variants.${index}.mrp`,
                                    );

                                    if (Number(value) >= Number(mrp)) {
                                      return "Price must be less than MRP";
                                    }

                                    return true;
                                  },
                                },
                              })}
                              onKeyDown={(e) => {
                                // Allow backspace, left and right arrow keys
                                if (
                                  e.key === "Backspace" ||
                                  e.key === "ArrowLeft" ||
                                  e.key === "ArrowRight"
                                ) {
                                  return; // Allow the action to continue
                                }

                                // Allow digits and decimal point
                                if (!/[\d.]/.test(e.key)) {
                                  e.preventDefault(); // Block the invalid key
                                }

                                // Prevent multiple decimal points
                                if (
                                  e.key === "." &&
                                  e.target.value.includes(".")
                                ) {
                                  e.preventDefault(); // Block adding another decimal point
                                }
                              }}
                            />
                            {errors?.variants?.[index]?.price && (
                              <span className="text-danger">
                                {errors.variants[index].price.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>PV</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`variants.${index}.pv`} // Register color for the variant
                              placeholder="PV"
                              className={classNames("", {
                                "is-invalid": errors?.variants?.[index]?.pv,
                              })}
                              {...register(`variants.${index}.pv`, {
                                required: "PV is required",
                              })}
                              onKeyDown={(e) => {
                                // Allow backspace, left and right arrow keys
                                if (
                                  e.key === "Backspace" ||
                                  e.key === "ArrowLeft" ||
                                  e.key === "ArrowRight"
                                ) {
                                  return; // Allow the action to continue
                                }

                                // Allow digits and decimal point
                                if (!/[\d.]/.test(e.key)) {
                                  e.preventDefault(); // Block the invalid key
                                }

                                // Prevent multiple decimal points
                                if (
                                  e.key === "." &&
                                  e.target.value.includes(".")
                                ) {
                                  e.preventDefault(); // Block adding another decimal point
                                }
                              }}
                            />
                            {errors?.variants?.[index]?.pv && (
                              <span className="text-danger">
                                {errors.variants[index].pv.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  {fields.length > 1 && (
                    <button
                      className="mt-3 add-varient"
                      type="button"
                      onClick={() => remove(index)} // Remove the variant
                    >
                      Remove Variant
                    </button>
                  )}
                  <hr />
                </div>
              ))}
            </div>
            <hr />
            <div className="text-center">
              <button
                type="button"
                className="add-varient"
                onClick={() => append({})}
              >
                + Add Variant
              </button>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <div className="text-center mt-4 mx-2">
              <button
                className="Back-button"
                // type="submit"
                onClick={() => navigate("/products")}
              >
                Cancel
              </button>
            </div>

            <div className="text-center mt-4 mx-2">
              <button
                className="schedule-button"
                onClick={handleSubmit(onSubmit)}
                disabled={submitLoading}
              >
                {submitLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Creating...
                  </>
                ) : (
                  "Create Product"
                )}
              </button>
            </div>
          </div>
        </Form>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Create;
